import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./OrderReportUIHelpers";

const OrderReportUIContext = createContext();

export function useOrderReportUIContext() {
  return useContext(OrderReportUIContext);
}

export const OrderReportUIConsumer = OrderReportUIContext.Consumer;

export function OrderReportUIProvider({ orderReportUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initOrderReport = {
    id: undefined,
    firstName: "",
    lastName: "",
    email: "",
    userName: "",
    gender: "Female",
    status: 0,
    dateOfBbirth: "",
    ipAddress: "",
    type: 1,
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    initOrderReport,
    newOrderReportButtonClick: orderReportUIEvents.newOrderReportButtonClick,
    openEditOrderReport: orderReportUIEvents.openEditOrderReport,
  };

  return <OrderReportUIContext.Provider value={value}>{children}</OrderReportUIContext.Provider>;
}
